<div class="page-content-inner" fxFlex fxLayoutAlign='center'>
  <div class="content mat-typography">

    <div fxLayout="column" fxLayoutAlign='start' class="header">
      <h1>Learn about the Gazebo App</h1>
      <p>Explore the server API, and brush up on how to use Fuel for your simulation needs.</p>
    </div>

    <div fxLayout="row" fxLayoutAlign='space-around' fxLayoutGap="40px" fxFill>

      <a class='card' routerLink="/api">
        <p><mat-icon title="API">api</mat-icon></p>
        <section>API</section>
        <p>Server API documentation.</p>
      </a>
  
      <a class='card' href="https://openrobotics.freshdesk.com">
        <p><mat-icon title="Documentation">library_books</mat-icon></p>
        <section>Documentation</section>
        <p>Guides, and documentation about the Gazebo App.</p>
      </a>
    </div>
  </div>
</div>
